import { cva, type VariantProps } from 'class-variance-authority';
import { $typo } from '@/shared/token';
import { cn } from '@/shared/utils/cn';

type TextTag = React.ElementType<React.HTMLAttributes<HTMLElement>>;

const textVariants = cva('', {
  variants: {
    typography: $typo.typography,
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
    },
    lineLimit: {
      0: 'line-clamp-0',
      1: 'line-clamp-1',
      2: 'line-clamp-2',
      3: 'line-clamp-3',
      none: 'line-clamp-none',
    },
  },
  defaultVariants: {
    typography: 'typo-text-m',
    align: 'left',
    lineLimit: 'none',
  },
});

const Text = ({
  className,
  tag = 'span',
  typography,
  lineLimit,
  align,
  children,
  ...props
}: {
  tag?: TextTag;
} & React.HTMLAttributes<HTMLElement> &
  VariantProps<typeof textVariants>) => {
  const Comp = tag;

  return (
    <Comp
      {...props}
      className={cn(textVariants({ typography, align, lineLimit }), className)}
    >
      {children}
    </Comp>
  );
};

export { Text, textVariants };
